import styled, { css } from 'styled-components';
import { Link } from '../../../../../components/Link/Link';
export const Popup = styled.div `
  position: absolute;
  display: inline-block;
  top: 50px;
  right: -45px;
  padding-top: 20px;
`;
export const PopupContentWrapper = styled.div `
  border-radius: 4px;
  padding: 15px;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  box-shadow: 0 0 35px rgb(0 0 0 / 20%);
  z-index: 0;
  width: 100%;

  &::after {
    content: '';
    position: absolute;
    top: 10px;
    right: 49px;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-bottom: 20px solid ${({ theme }) => theme.colorsV2.ui.background.primary};
  }
`;
export const PopupContent = styled.div `
  display: inline-flex;
  border-radius: 4px;
  width: 100%;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  z-index: 0;
`;
export const ListItem = styled.li `
  display: block;
  font-weight: 400;
  color: ${({ theme }) => theme.colorsV2.font.textPrimary};
  ${(props) => props.hasBorder ? `border-bottom: 1px solid ${props.theme.colorsV2.ui.border.primary};` : ''}

  a {
    font-weight: 400;
  }

  &:first-child a {
    padding-top: 2px;
  }

  &:last-child a {
    padding-bottom: 2px;
  }

  ${({ hasBadge }) => hasBadge &&
    css `
      display: flex;
      align-items: center;
    `}
`;
export const ListItemLink = styled(Link) `
  width: 100%;
  height: 100%;
  display: inline-flex;
  align-items: center;
  padding: 12px 0;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  ${({ withIcon }) => withIcon &&
    css `
      span:last-child {
        margin-left: 10px;
      }
    `}
`;
//# sourceMappingURL=Popup.styled.js.map